import { UserPathGroupData } from "../../models/app-data-model";
import UserPathCard from "../user-path-card/UserPathCard";
import React from 'react';
import './UserPathGroup.scss';

export type UserPathGroupProps = {
  user_path_group: UserPathGroupData;
};

const UserPathGroup: React.FC<UserPathGroupProps> = ({ user_path_group }: UserPathGroupProps) => {
  const userPathGrid = user_path_group.user_path_cards.map((card, index) => (
    <UserPathCard user_path_card={card} key={index}></UserPathCard>
  ));

  return(
      <section className={`upg-group ${user_path_group.variant_choser}`}>
        {userPathGrid}
      </section>
  );
};

export default UserPathGroup;
